import React from "react";
import { WealthManagementLayout } from "@/modules/wealth-management/components/WealthManagementLayout";

export const WealthManagement: React.FC = () => <WealthManagementLayout />;
